import React from 'react'
import { Route, Routes } from 'react-router'
import LoginPage from '../app/auth/pages/LoginPage'

function AuthRoutes() {
  return (
    <Routes>
        <Route path="/" element={<LoginPage/>}></Route>
        <Route path="/auth/login" element={<LoginPage/>}></Route>
    </Routes>
  )
}

export default AuthRoutes